export default class GlobalCategory {
    public id?: number;
    public name_fr?: string;
    public name_en?: string;
    public name_nl?: string;

    constructor(init?: Partial<GlobalCategory>) {
        Object.assign(this, init);
    }
}